export default "__VITE_ASSET__DbuDju7s__"